import { bannerOffset } from '../navigation-onscroll';

export default {
  init() {
    // JavaScript to be fired on the home page

    window.removeEventListener('load', bannerOffset);

    // var banner = $('.banner');
    // var bannerHeight = banner.outerHeight();
    // var slideContainers = $('.slide__container');

    // slideContainers.css('padding-top', (bannerHeight + 40) + 'px');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js